// import axios from "axios";
import axiosInstance from "../axios";
const { REACT_APP_LOGIN_API_BASEURL } =
  process.env;

const courseStatus = {
  drafts: 1,
  isReview: 2,
  published: 3,
  archived: 4,
};
const url = window.location.href;
const startIndex = url.indexOf("rst=") + 4;
const endIndex = url.length;
const token = url.substring(startIndex, endIndex);

const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
};

const fetchCourses = async (page, category, subCategory, level) => {
  try {
    const safeCategory = category ? category.toLowerCase() : "";
    const safeSubCategory = subCategory ? subCategory.toLowerCase() : "";
    if (  page == null || page === undefined) {
      page = 1;
    }
    const response = await axiosInstance.get(
      category == null && subCategory == null && level == null
        ? `course?page=${page}`
        : level == null && subCategory == null
          ? `course?category=${encodeURIComponent(safeCategory)}&page=${page}`
          : level == null
            ? `course?category=${encodeURIComponent(safeCategory)}&subCategory=${encodeURIComponent(safeSubCategory)}&page=${page}`
            : category == null
              ? `course?level=${level}&page=${page}`
              : level === "All"
                ? `course?category=${encodeURIComponent(safeCategory)}&subCategory=${encodeURIComponent(safeSubCategory)}&page=${page}`
                : `course?category=${encodeURIComponent(safeCategory)}&subCategory=${encodeURIComponent(safeSubCategory)}&level=${level}&page=${page}`
    );
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};

const fetchFilteredCourses = async (page, category, subCategory, level, search) => {
  try {
    let data;
    let url;
    if (subCategory === "Popular") {
      data = {
        category: category,
        subCategory: "",
        level: level,
        search: search,
      };
      for (let key in data) {
        if (!data[key]) {
          delete data[key];
        }
      }
      url = `${REACT_APP_LOGIN_API_BASEURL}/course?tags=popular&page=${page}`;
    } else {
      data = {
        category: category,
        subCategory: subCategory,
        level: level,
        search: search,
      };
      for (let key in data) {
        if (!data[key]) {
          delete data[key];
        }
      }
      url = `${REACT_APP_LOGIN_API_BASEURL}/course?page=${page}`;
    }
    const response = await axiosInstance.post(url, data);
    return response.data;
  } catch (error) {
    console.error("Error fetching filtered courses:", error);
    throw error;
  }
};

const myCourses = async (key, url, page) => {
  try {
    const response = await axiosInstance.get(
      `${url}?page=${page}${courseStatus[key] ? `&status=${courseStatus[key]}` : ""}`
    );
    //console.log("mycourse data", response.data);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching my courses:", error);
    throw error;
  }
};

const purchasedCourses = async (page) => {
  try {
    const response = await axiosInstance.get(`course/purchased?page=${page}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching purchased courses:", error);
    throw error;
  }
};

const profileResetPassword = async (data) => {
  const currentUrl = window.location.href;
  const sIndex = currentUrl.indexOf("rst=");
  let dynamicToken = "";
  if (sIndex !== -1) {
    dynamicToken = currentUrl.substring(sIndex + 4);
  }
  return axiosInstance.post(`${REACT_APP_LOGIN_API_BASEURL}/reset`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${dynamicToken}`,
    },
  });
};

const profileForgetPassword = async (data) => {
  return axiosInstance.post("/forgot-password", data);
};

const updateProfile = async (profileData) => {
  return axiosInstance.put("user/profile", profileData);
};

const viewAwardCourse = async (page) => {
  try {
    const response = await axiosInstance.get(`course/all/certificates?page=${page}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching award courses:", error);
    throw error;
  }
};

const postContactDetail = async (data) => {
  return axiosInstance.post("/contact/demo-request", data);
};

const userSignup = async (data) => {
  return axiosInstance.post("/sign-up", data);
};

const userStatics = async () => {
  return axiosInstance.get("admin/statistics");
};
const fetchCourseById = async (url, data) => {
  try {
    const response = await axiosInstance.get(`${url}/${data}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching course by ID:", error);
    throw error;
  }
};

// Looks up a course/program by its URL slug (e.g. "generative-ai-fundamentals")
// instead of its numeric ID. Used for program pages, whose URLs only ever
// carry a slug, so a direct hit / refresh / shared link can still resolve
// the course without relying on react-router navigation state.
const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");

const fetchCourseBySlug = async (slug) => {
  try {
    const response = await axiosInstance.get(`course/slug/${slug}`);
    if (response?.data?.data) {
      return response.data.data;
    }

    // Older courses have no stored Slug, so the lookup above misses them.
    // Fall back to a name search and match on the same slugify used to build
    // program URLs. "%" between the words lets the LIKE match skip punctuation.
    const search = await axiosInstance.get("course", {
      params: { search: slug.split("-").join("%") },
    });
    const list = search?.data?.data?.data || search?.data?.data || [];
    return Array.isArray(list)
      ? list.find((course) => slugify(course.CourseName || "") === slug) || null
      : null;
  } catch (error) {
    console.error("Error fetching course by slug:", error);
    throw error;
  }
};

export const courseService = {
  myCourses,
  fetchCourses,
  fetchFilteredCourses,
  purchasedCourses,
  updateProfile,
  profileForgetPassword,
  profileResetPassword,
  viewAwardCourse,
  postContactDetail,
  userSignup,
  userStatics,
  fetchCourseById,
  fetchCourseBySlug
};
